module.exports = __webpack_public_path__ + "img/hotel-nova-sintra.850eabec.jpg";